import { MembershipServiceModule } from '@b2c/common/services/membership/membership.service';
import { ThemesServiceModule } from '@b2c/common/services/themes/themes.service';
import angular from 'angular';
import uiRouter from 'angular-ui-router';

export const MembershipHeadingDirectiveModule = angular.module('acme.common.directive.membershipHeading', [
  uiRouter,
  MembershipServiceModule,
  ThemesServiceModule
])
.directive('membershipHeading', [ '$state', '$timeout', 'MembershipService', 'ThemesService', function($state, $timeout, MembershipService, ThemesService) {

    return {
      restrict: 'A',
      replace: true,
      transclude: true,
      templateUrl: 'common/directives/membershipHeading/membershipHeading.tpl.html',
      scope: {
        heading: '@'
      },
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', function($scope) {

        $scope.membershipHeading = {
          model: {},
          isValid: false,
          show: ThemesService.getCompany('membership'),
          showMembershipPurchase: true,
          heading: 'Current Membership',

          init: function() {
            var member = MembershipService.getPrimaryMember();

            if (member) {
              this.isValid = true;
              this.model = member;
            }else{
              this.isValid = false;
              this.model = {};
            }

            if ($scope.heading) {
              this.heading = $scope.heading;
            }

            console.log('MembershipHeading::init', this.model);
          },

          verify: function() {
            $timeout(function() {
              $scope.$emit('MembershipHeading::Verify');
            }, 100);
          },

          join: function() {
            $timeout(function() {
              $scope.$emit('MembershipHeading::Join');
            }, 100);
          },

          renew: function() {
            $timeout(function() {
              $scope.$emit('MembershipHeading::Renew');
            }, 100);
          }

        };

        $scope.membershipHeading.init();


      }]

    };

}]).name;
